import { Scene } from "onearm";
import { FullScreenBackgroundFill } from "onearm";
import { Signal } from "typed-signals";
import { PayTablesPageController } from "./PayTablesPage";

export class InfoPopup extends Scene {
    constructor({ screen, ...data }) {
        super({ name: "InfoPopup", layer: "popups" });

        this.fill = this.addChild(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        );
        this.layout = this.buildLayout("InfoPopup");

        this.pagesContainer = this.layout.find("pagesContainer");
        this.pageCount = this.pagesContainer?.children?.length ?? 0;

        this.payTablesPage = new PayTablesPageController(this.layout, data);

        this.layout.forAll("PageControls.RightButton", (btn) => {
            btn.onPress.connect(this.handlePressNext.bind(this));
        });
        this.layout.forAll("PageControls.LeftButton", (btn) => {
            btn.onPress.connect(this.handlePressPrev.bind(this));
        });

        this.currentPage = 0;
        this.updatePageNumber(this.currentPage);
        this.onPressClose = new Signal();

        this.layout.forAll("CloseButton", (btn) => {
            btn.onPress.connect(() => this.onPressClose.emit());
        });
    }

    handlePressNext() {
        this.currentPage++;
        if (this.currentPage >= this.pageCount) {
            this.currentPage = 0;
        }
        this.updatePageNumber(this.currentPage);
    }

    handlePressPrev() {
        this.currentPage--;
        if (this.currentPage < 0) {
            this.currentPage = this.pageCount - 1;
        }
        this.updatePageNumber(this.currentPage);
    }

    updatePageNumber(page) {
        this.currentPage = page;

            this.layout.forAll("pagesContainer", (container) => {
                container.children.forEach((child, index) => {
                    child.visible = index === page;
                });
            });

            this.layout.forAll("PageNumber", (text) => {
                text.text = `Page ${page + 1}/${this.pageCount}`;
            });
    }
}
